import React, { useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';     

export default function BasicDemo(props) {
    const [selected2Option, setSelected2Option] = useState(null);
    let itemList=[];
    var default_value2=[];
    console.log(props.value);
    console.log(props.remote_source);
    for (var key in props.remote_source) {
        itemList.push( { code: key, name: props.remote_source[key]});
  
      if(props.value && typeof props.value !== 'undefined' && props.value==key ){          
         default_value2.push( { code: key, name: props.remote_source[key]});
      }
     }

     if(props.value && typeof props.value !== 'undefined'  && typeof default_value2[0] !== 'undefined' ){
        return (
            <>
            <label className="control-label justify-content-start" htmlFor={props.id}>{props.label} </label>
                    <div>
                    <Dropdown
                         value={selected2Option==null?default_value2[0]:selected2Option}
                        onChange={(e)=>{
                           setSelected2Option(e.value);                        
                            props.onChange(e.value);
                        }}
                        options={itemList}
                        optionLabel="name"
                        className="w-full lg:w-24rem"
                        />
            </div>
            </>

        )
     }else{
        return (
            <>
               <label className="control-label justify-content-start" htmlFor={props.id}>{props.label} </label>
                    <div>
                    <Dropdown
                        value={selected2Option}
                        onChange={(e)=>{
                            setSelected2Option(e.value);                        
                            props.onChange(e.value);
                        }}
                        options={itemList}
                        optionLabel="name"
                        className="w-full lg:w-24rem"
                        />
            </div>
            </>
    
        )
     }
}